import { useMutation } from '@tanstack/react-query'
import { blockConsumer } from '..'

const useBlockConsumer = () =>
  useMutation({
    mutationFn: blockConsumer,
  })

export default useBlockConsumer
